const Cards = new Map();
Cards.set('CL OURO LJ', 'LUIZA OURO');
Cards.set('CL PREF LJ', 'LUIZA PREFERENCIAL');

export default Cards;
